import { createRng } from "@/lib/seededRandom";
import type { Project } from "@/types";

const rng = createRng(334455);

function milestones(titles: string[], doneCount: number) {
  return titles.map((title, i) => ({
    title,
    done: i < doneCount,
    date: rng.daysAgo(i < doneCount ? 30 : -1, i < doneCount ? 5 : 0),
  }));
}

export const PROJECTS: Project[] = [
  {
    id: "proj-ai-agent-rollout",
    name: "AI Agent Rollout — Client Ops Copilot",
    description: "Deploy AI copilots across client success and service delivery to automate reporting and triage.",
    owner: "Kevin Tan",
    department: "Technology / AI",
    status: "on-track",
    progress: 62,
    startDate: rng.daysAgo(90),
    targetDate: rng.daysFromNow(60),
    priority: "critical",
    milestones: milestones(["Pilot with 5 accounts", "Automate weekly reporting", "Expand to 50 accounts", "Company-wide rollout"], 2),
  },
  {
    id: "proj-executive-dashboard",
    name: "Executive Operating System",
    description: "Replace static reporting with a live executive command center across revenue, ops, and people.",
    owner: "Maryanne Castro",
    department: "Technology / AI",
    status: "on-track",
    progress: 78,
    startDate: rng.daysAgo(45),
    targetDate: rng.daysFromNow(14),
    priority: "critical",
    milestones: milestones(["Define KPI model", "Build core platform", "Pilot with leadership", "Company rollout"], 3),
  },
  {
    id: "proj-department-restructuring",
    name: "Client Success Restructuring",
    description: "Rebalance AM/OM book-of-business ratios to reduce escalation load per manager.",
    owner: "Renata Cruz",
    department: "Client Success",
    status: "at-risk",
    progress: 34,
    startDate: rng.daysAgo(60),
    targetDate: rng.daysFromNow(45),
    priority: "high",
    milestones: milestones(["Audit current book-of-business", "Design new pod structure", "Migrate top-20 accounts", "Full migration"], 1),
  },
  {
    id: "proj-client-advisory-program",
    name: "Client Advisory Board Program",
    description: "Launch a quarterly advisory board with top-tier clients to guide roadmap and retention strategy.",
    owner: "James Santos",
    department: "Client Success",
    status: "planning",
    progress: 12,
    startDate: rng.daysAgo(14),
    targetDate: rng.daysFromNow(90),
    priority: "medium",
    milestones: milestones(["Select advisory cohort", "Draft charter", "Kickoff session", "First quarterly review"], 0),
  },
  {
    id: "proj-revenue-campaign-q3",
    name: "Q3 Expansion Revenue Campaign",
    description: "Targeted expansion campaign for high-health, low-usage accounts identified by AI Insights.",
    owner: "Marcus Ellison",
    department: "Sales",
    status: "on-track",
    progress: 51,
    startDate: rng.daysAgo(40),
    targetDate: rng.daysFromNow(20),
    priority: "high",
    milestones: milestones(["Segment target accounts", "Enable AM playbook", "Launch outreach", "Close review"], 2),
  },
  {
    id: "proj-process-improvement-onboarding",
    name: "Client Onboarding Process Redesign",
    description: "Cut onboarding time-to-value by standardizing the first-30-day playbook across all TLs.",
    owner: "Diego Villanueva",
    department: "Service Delivery",
    status: "delayed",
    progress: 28,
    startDate: rng.daysAgo(75),
    targetDate: rng.daysFromNow(-5),
    priority: "high",
    milestones: milestones(["Map current-state journey", "Draft new playbook", "Pilot with 10 accounts", "Roll out org-wide"], 1),
  },
  {
    id: "proj-automation-invoicing",
    name: "Automated Invoicing & Collections",
    description: "Automate invoice generation and overdue follow-ups to reduce DSO.",
    owner: "Andres Osei",
    department: "Finance",
    status: "completed",
    progress: 100,
    startDate: rng.daysAgo(150),
    targetDate: rng.daysAgo(10),
    priority: "medium",
    milestones: milestones(["Vendor selection", "Integration build", "Pilot billing cycle", "Full cutover"], 4),
  },
];
